function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  transform: "translate(1 1)"
}, React.createElement("circle", {
  cx: 14.798,
  cy: 29.202,
  r: 14.405
}), React.createElement("circle", {
  cx: 14.798,
  cy: 26.321,
  r: 5.762
}), React.createElement("path", {
  d: "M24.1837619 40.128873C22.4080068 36.5713944 18.7736673 34.3235629 14.797619 34.3235629 10.8215708 34.3235629 7.18723129 36.5713944 5.41147619 40.128873M6.1547619 9.03571429L6.1547619 3.27380952C6.1547619 1.68270346 7.44460822.392857143 9.03571429.392857143L29.4501429.392857143C30.2136859.393020169 30.9459364.696282412 31.4860159 1.23601587L42.7639841 12.5139841C43.3037176 13.0540636 43.6069798 13.7863141 43.6071429 14.5498571L43.6071429 40.7261905C43.6071429 42.3172965 42.3172965 43.6071429 40.7261905 43.6071429L32.0833333 43.6071429"
}), React.createElement("path", {
  d: "M43.6071429,14.797619 L32.0833333,14.797619 C30.4922273,14.797619 29.202381,13.5077727 29.202381,11.9166667 L29.202381,0.392857143"
}));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 46 46",
    className: "icon",
    style: {
      "height": "1em",
      "width": "1em"
    }
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/user-file.e78bf38f.svg";
export { SvgComponent as ReactComponent };